import React from "react";
import { ExpandableText } from "components/ExpandableText";



const AboutSection = () => {

  return (

    <div className="container mx-auto px-4">
      <div className="items-center flex flex-wrap pt-20"></div>
      <div className="w-full md:w-9/12 px-4 mr-auto ml-auto">
        <div className="text-warmGray-200 p-3 text-center inline-flex items-center justify-center w-16 h-16 mb-6 shadow-lg rounded-full bg-lsfm-primary-500">
          <i className="fas fa-user-friends text-xl"></i>
        </div>
        <h3 className="text-3xl mb-2 font-semibold leading-normal text-warmGray-800">
          Par mums
        </h3>
        <p className="text-lg leading-relaxed mt-4 mb-4 text-warmGray-600">
          Konferenci organizē Latvijas Kaķu Medicīnas Biedrība (Latvian Society of Feline Medicine jeb LSFM) dibinātājas Aina Pahomova un Ksenija Polonska. LSFM apvieno veterinārmedicīnas profesionāļus un kaķu labklājības speciālistus, lai dalītos zināšanās, veicinātu kaķu veselību un palīdzētu cilvēkiem rūpēties par saviem mīluļiem vislabākajā veidā. Mūsu mērķis ir nodrošināt aktuālu, pierādījumos balstītu informāciju, veicināt kaķu labklājību un atbalstīt veterinārmedicīnas kopienu Latvijā.
        </p>

      </div>

      <div className="flex flex-wrap items-center mt-20">

        <div className="w-full lg:w-10/12  px-4 mr-auto ml-auto">
          <div className="relative flex flex-col lg:flex-row min-w-0 break-words p-4  bg-white w-full mb-6 shadow-lg rounded-lg bg-lsfm-primary-500">
            <div className="relative flex flex-col lg:w-3/12">

              <img
                alt="Aina Pahomova - BSc Biovet Sci, SVN, uzvedības un labturības speciāliste"
                src={require("../../assets/img/Aina_profile.jpg")}
                className="h-480-px  mx-auto object-contain rounded-lg"
                style={{ objectFit: "cover" }}
              />

            </div>
            <div className="flex flex-col lg:w-9/12 justify-center p-8 ">
              <h4 className="text-xl font-bold text-white pb-2">
                Aina Pahomova
              </h4>
              <h5 className="text-md font-semibold text-white pb-4">
                BSc Biovet Sci, SVN, uzvedības un labturības speciāliste
              </h5>



              <ExpandableText
                text={`Mājas kaķu, suņu, trušu un grauzēju uzvedības un labturības speciāliste. Darbs pētniecības nozarē — dzīvnieku turēšanas, veselības, barošanas un sociālās uzvedības jomā. Bioveterinārijas zinātņu bakalaurs. BSc (Hons) Bioveterinary Science, the University of the West of England. Viena no Latvijas Kaķu Medicīnas Biedrības (LSFM) dibinātājām. Pašlaik studē Karaliskās Veterināro Ķirurgu Koledžas (RCVS) veterināro medicīnas māsu programmā (Veterinary Nursing, Coleg Gwent, Wales) un strādā veterinārā klīnikā Velsā. Mācību un zinātnisko materiālu autore žurnālā InFocus (The Improve Veterinary Practice), kā arī starptautiskā lektore konferencēs un apmācību kursos speciālistiem. Brīvprātīgā konsultante Ukrainas karā cietušo dzīvnieku adoptētājiem. Nepārtraukti mācās, papildinot savas zināšanas dažādās konferencēs, semināros, kursos utt.
     
     Vairāku organizāciju biedre:
     APBC (a Student CAB Member of the Association of Pet Behaviour Counsellors);
     BSAVA (British Small Animal Vetinary Association);
     BVNA (British Veterinary Nursing Association);
     ISFM (International Society of Feline Medicine);
     Grisha Steward Academy;
     Dog and Cat Science Club biedre.`}
                maxLength={400}
                clampClass={"line-clamp-7"}
              />


            </div>
          </div>

        </div>

        <div className="w-full lg:w-10/12  px-4 mr-auto ml-auto">
          <div className="relative flex flex-col lg:flex-row min-w-0 break-words p-4  bg-white w-full mb-6 shadow-lg rounded-lg bg-lsfm-primary-500">

            <div className="flex flex-col lg:w-9/12 justify-center p-8 order-2 lg:order-1">
              <h4 className="text-xl font-bold text-white pb-2">
                Ksenija Polonska
              </h4>
              <h5 className="text-md font-semibold text-white pb-4">
                Veterinārārste-dermatoloģe
              </h5>



              <ExpandableText
                text={`Veterinārmedicīna Ksenijai Polonskai ir aicinājums. Pārliecināta, ka savstarpēja cieņa starp klientu un veterinārārstu, kā arī empātiska attieksme pret pacientiem ir pamats labākajiem ārstēšanas rezultātiem. Viņa konsekventi ievēro Cat Friendly un Pet Friendly principus, nodrošinot saudzīgu, līdzsvarotu un uz pacienta vajadzībām vērstu pieeju. Viena no Latvijas Kaķu Medicīnas Biedrības (LSFM) dibinātājām. Regulāri papildina zināšanas starptautiskās konferencēs un kursos, kā arī, aktīvi dalās savās zināšanās ar kolēģiem un sabiedrību — publicē rakstus Veterinārajā Žurnālā, piedalās podkāstos, lasa lekcijas, iesaistās zinātniskos pētījumos un uztur izglītojošu sociālā tīkla Instagram profilu @veterinary.lv, kur atklāti runā par veterinārārstes ikdienu, dzīvnieku labturību un veselības aprūpi. Nepārtraukti mācās, papildinot savas zināšanas dažādās konferencēs, semināros, kursos utt. 
     
     Vairāku organizāciju biedre: 
     Latvijas Veterinārārstu Biedrībā (LVB); 
     LVB Mazo Dzīvnieku Veterinārārstu Sekcijā (MDzVS); 
     WSAVA (World Small Animal Veterinary Association); 
     FECAVA (Federation of European Companion Animal Veterinary Association); 
     European Society of Veterinary Dermatology (ESVD); 
     ISFM (International Society of Feline Medicine); 
     VetDerm PRO un LearnVetderm - grupas veterinārajiem speciālistiem dermatoloģijā.
     `}
                maxLength={400}
                clampClass={"line-clamp-7"}
              />


            </div>
            <div className="relative flex flex-col lg:w-3/12 order-1 lg:order-2">

              <img
                alt="..."
                src={require("../../assets/img/Ksenija_profile.jpg")}
                className=" mx-auto object-contain rounded-lg"
                style={{ objectFit: "cover" }}
              />

            </div>
          </div>

        </div>

        <div className="w-full lg:w-4/12 ml-auto mr-auto px-4">
          <img
            alt="..."
            className="max-w-full"
            src={require('../../assets/img/art-about.png')}
          />
        </div>
      </div>
    </div>
  );
};



export default AboutSection;